// Whose payment it is when someone else's subscription pays for a member's place: the Accelerator's
// business partner seats, copied in on the switch with the lead who pays as the row's payer
// (hub.my_access()'s paid_by_other and payer_name, migration 20261011120000). The payment banner inside the
// product, the Library's banner and the paused page then name the payer's payment, not "your payment", and
// leave Update card off, because the card on that subscription is the payer's: Stripe's page for the
// member's own customer, or Account, can't change it. Pure: it imports only lib/names.js, which is pure
// too, so a test can load it as it is. The payer is named by their first name only (Adam, 11 Oct).
import { realFirstName } from '../lib/names.js'

export const paidByOther = access => Boolean(access?.paid_by_other)

// The payer's first name as the database gives it, or null (they pay for themselves, the payer's record has
// been anonymised, or the name is the stand-in "there" or a bare title, which the database keeps out too)
const payerName = access => (typeof access?.payer_name === 'string' && realFirstName(access.payer_name)) || null

// What they hold: a membership on a mastermind (the Accelerator's 12-month membership), a place on anything else
export const placeWord = product => (product?.type === 'mastermind' ? 'membership' : 'place')

// "Marcus's payment for your membership", or "The payment for your membership" with no name to give
export function payerPayment(access, what) {
  const name = payerName(access)
  return `${name ? `${name}'s` : 'The'} payment for your ${what}`
}

// Who sorts it: "while they sort it", or "while it's sorted" with no name to give
export const payerSorts = access => (payerName(access) ? 'while they sort it' : "while it's sorted")

// "Marcus's payment", or "the payment for it", after "until"
export function payerPaymentShort(access) {
  const name = payerName(access)
  return name ? `${name}'s payment` : 'the payment for it'
}
